
export default (state = {}, action) => {
  switch (action.type) {
    case 'TAGS_FETCH_SUCCESS':
      return {
        tags: action.payload,
        error: false
      }
    case 'TAGS_FETCH_FAILURE':
      return {
        tags: [],
        error: true
      }
    default:
      return state
  }
}